$(document).ready(function () {
    $(document).on('click', '[data-product-option="option1"] [data-button]', function () {
        var value = $(this).attr('data-option-value');
        if ($(document).find('.td-bundle-variant--select').length > 0) {
            $(document).find('.td-bundle-variant--select[data-option-position="1"]').val(value).trigger('change')
        }
    })
    $(document).on('click', '[data-product-option="option2"] [data-button]', function () {
        var value = $(this).attr('data-option-value');
        console.log(value)
        if ($(document).find('.td-bundle-variant--select').length > 0) {
            $(document).find('.td-bundle-variant--select[data-option-position="2"]').val(value).trigger('change')
        }
    });

    const guide_tailles = {
        "a+g": "XS/S", "a+h": "M", "a+i": "M", "a+j": "L", "a+k": "L", "a+l": "XL", "a+m": "XL",
        "b+g": "M", "b+h": "M", "b+i": "M", "b+j": "L", "b+k": "L", "b+l": "XL", "b+m": "XL",
        "c+g": "L", "c+h": "L", "c+i": "L", "c+j": "L", "c+k": "XL", "c+l": "XL", "c+m": "XL",
        "d+g": "L", "d+h": "L", "d+i": "L", "d+j": "L", "d+k": "XL", "d+l": "XL", "d+m": "XL",
        "e+g": "XL", "e+h": "XL", "e+i": "XL", "e+j": "XL", "e+k": "XL", "e+l": "XL", "e+m": "XL",
        "f+g": "XL", "f+h": "XL", "f+i": "XL", "f+j": "XL", "f+k": "XL", "f+l": "XL", "f+m": "XL"
    };

    $(document).on('change', '.taille-buste-select', function () {
        var busteselect = $(this).val();
        var hancheselect = $(this).parentsUntil('.taille-form').find('.taille-tour-de-hanche-select').val();
        var totalval = busteselect + '+' + hancheselect;
        if (hancheselect) {
            $(this).parentsUntil('.taille-form').find('.resultat-container .resultat-taille').html('<p class="conseil-taille">Line vous conseille de choisir la taille <strong>'+guide_tailles[totalval]+'</strong></p>');
        }

    });
    
      $(document).on('change', '.taille-tour-de-hanche-select', function () {
        var busteselect = $(this).val();
        var hancheselect = $(this).parentsUntil('.taille-form').find('.taille-buste-select').val();
        var totalval = hancheselect + '+' + busteselect;
        if (hancheselect) {
            $(this).parentsUntil('.taille-form').find('.resultat-container .resultat-taille').html('<p class="conseil-taille">Line vous conseille de choisir la taille <strong>'+guide_tailles[totalval]+'</strong></p>');
        }

    });



});